import { useEffect } from "react";
import { useSelector } from "react-redux";
import { Outlet, useNavigate } from "react-router-dom";
import { getToast } from "../common/utils";

const AuthLayout = () => {
  const storeData = useSelector((state) => state.mainReducer);
  const { userData } = storeData;
  const navigate = useNavigate();
  const toast = getToast("User is Inactive");
  useEffect(() => {
    // need a logic here a user comes from if user not entered from this route,
    // it means that user is not authenticated user, he entered here bypass..
    // if (userData) {
    //   navigate("/app");
    //   // if (userData.roleId === "fV0s001") {
    //   //   navigate("/app");
    //   // }
    // }
    if (userData && userData.status === "active") {
      navigate("/app");
    }
    if (userData && userData.status !== "active") {
      console.log("user inactive");
    }
  }, [userData, navigate]);

  //  return !userData && <Outlet />;
  return <Outlet />;
};
export default AuthLayout;

//    return sendError(next, "error.message", 500, { logOut: true });
